import { KeyValue } from "@/main/models/common";
import { BodyshopTypeActionTypes, BodyshopTypeTypes } from "./bodyshopTypeTypes";

export function getBodyshopType(): BodyshopTypeActionTypes {
	return {
		type: BodyshopTypeTypes.GET_BODYSHOP_TYPE,
	};
}

export function saveBodyshopType(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): BodyshopTypeActionTypes {
	return {
		type: BodyshopTypeTypes.SAVE_BODYSHOP_TYPE,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerBodyshopType(): BodyshopTypeActionTypes {
	return {
		type: BodyshopTypeTypes.RESET_REDUCER_BODYSHOP_TYPE,
	};
}
